import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneXray } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneXray = ({ getOneXray, OneXray, patient }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Xray, setXray] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneXray(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneXray;
    setLoading(loading);
    setError(error);
    if (data) {
      setXray(data);
    }
  }, [OneXray]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View X Ray"
        one={Xray}
        history={history}
      />
    );
  };
  return renderView();
};

const mapStateToProps = (state) => {
  return {
    OneXray: state.OneXray,
  };
};
export default connect(mapStateToProps, { getOneXray })(ViewOneXray);
